<template>
  <div v-if="data">
    <h2 class="text-black mb-3 pt-4">
      In Case You Missed It <small class="text-muted">(optional)</small>
    </h2>

    <div
      v-for="(audio, i) in data"
      :key="`audio-${i}`"
    >
      <form-control
        class="mb-3"
        v-model="audio.title"
        :errors="(error && error.errors.audios) ? error.errors.audios[i].title : []"
        :no-margin="true"
        :title="`Audio ${i + 1} Title`"
        placeholder="Enter audio title"
      />

      <div class="form-group">
        <label>Audio {{ i + 1 }} Source/Notes</label>

        <HtmlEditor
          v-model="audio.source"
          :token="`Bearer ${$login.getToken()}`"
          :image-upload-url="imageUploadUrl"
          :file-upload-url="fileUploadUrl"
        />
      </div>

      <form-control
        class="mb-5"
        v-model="audio.link"
        :errors="(error && error.errors.audios) ? error.errors.audios[i].title : []"
        :no-margin="true"
        :title="`Audio ${i + 1} Link`"
        placeholder="Enter audio link"
      />
    </div>

    <div class="form-group border-bottom pb-5 mb-3">
      <button
        @click="addAudio"
        type="button"
        class="btn btn-outline-secondary btn-block"
      >
        Add Audio
      </button>
    </div>
  </div>
</template>

<script>
import {HtmlEditor} from '@frontend/components'
export default {
  components: {
    HtmlEditor,
  },

  props: {
    value: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    data: null,
    error: null,
    imageUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/image',
    fileUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/file'
  }),

  mounted () {
    this.data = this.value
  },

  watch: {
    data () {
      this.$emit('input', this.data)
    },

    value () {
      this.data = this.value
    },
  },

  methods: {
    addAudio () {
      this.data.push({title: '', source: '', link: ''})
    },
  },
}
</script>
